// angular
import { Component, effect, inject, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
// components
import {
  buttonColors,
  ButtonComponent,
  buttonSizes,
  buttonVariants,
} from '../button/button.component';
import { LoginDialogComponent } from '@app/core/dialogs/login-dialog/login-dialog.component';
// services
import { DialogService } from '@app/core/shared/services/dialog.service';
import { AuthService } from '@shared/services/auth.service';
import { UserService } from '@shared/services/user.service';
import { SignupDialogComponent } from '@core/dialogs/signup-dialog/signup-dialog.component';

@Component({
  standalone: true,
  selector: 'pwj-register-button',
  imports: [ButtonComponent, TranslateModule],
  templateUrl: './register-button.component.html',
  styleUrl: './register-button.component.scss',
})
export class RegisterButtonComponent {
  public mobileVerified!: boolean;
  public isUserLoggedIn!: boolean;
  // inputs
  variant = input<buttonVariants>('primary');
  color = input<buttonColors>('white');
  size = input<buttonSizes>('medium');
  title = input<string>('');

  // dependencies
  private readonly _dialogService = inject(DialogService);
  private readonly _authService = inject(AuthService);
  private readonly _userService = inject(UserService);

  constructor() {
    effect(() => {
      this.mobileVerified = !!this._userService.userSignal()?.mobile_verified;
      this.isUserLoggedIn =
        (this._userService.userSignal()?.roles?.length || 0) > 0;
    });
  }

  openOtpDialog() {
    this._authService.updateUserSignUpState({
      mobile_verified: this._userService.userSignal().mobile_verified,
      mobile: this._userService.userSignal().mobile,
      state: 1,
    });
    this._dialogService.open(SignupDialogComponent, {
      width: 'none',
      height: 'none',
    });
  }

  public openLoginDialog = () => {
    this._dialogService.open(SignupDialogComponent, {
      width: 'none',
      height: 'none',
    });
  };
}
